export class AngularCoreIoCKeys {
    //IoCContainer
    public static IAngularCoreIoCContainer: string = 'IAngularCoreIoCContainer';

    //Implementations
    public static IAngularTranslation: string = 'IAngularTranslation';

    //Third party
    public static AngularTranslateService: string = 'AngularTranslateService';
}
